
import { Component, Vue } from 'vue-property-decorator';
import MemberForm from '@/views/member/MemberForm.vue';
import UserForm from '@/views/member/UserForm.vue';
import api from '@/api';

const { member } = api;

@Component({
  components: {
    MemberForm,
    UserForm,
  },
})
export default class UserCreate extends Vue {
  private loading = false;

  private user = {
    userId: null,
    email: null,
    taxId: null,
    firstName: null,
    lastName: null,
    gender: null,
    countryCode: null,
    mobile: '886',
    pid: null,
    birthday: null,
    city: null,
    area: null,
    address: null,
    currentCity: null,
    currentArea: null,
    currentAddress: null,
    isEnable: true,
    roles: [1],
    zipcode: null,
    profilePic: null,
    identityIdPic: null,
    identityIdPic2: null,
    taxCertificationPic: null,
    electronicSignature: null,
    isInBlackList: null,
  };

  private change(evt: any) {
    (this.user as any)[evt.key] = evt.value;
  }

  private async submit(valid: boolean) {
    if (valid) {
      this.loading = true;
      const parameters = {
        ...this.user,
        roleType: this.user.roles[0],
        birthday: new Date(`${this.user.birthday}T00:00:00`),
      };
      const { status } = await member.add(parameters);
      if (status === 1) {
        await this.$router.back();
      }
      this.loading = false;
    }
  }
}
